import ForgotPasswordView from './ForgotPasswordView';
export default ForgotPasswordView;
